module.exports = __webpack_public_path__ + "static/media/JesieOldenburg-resume.924e9e1f.pdf";